import React from 'react';
import ConditionalRenderer, { If } from '@components/ConditionalRenderer';
import { goBack } from '@utils';
import BackBtn from '@components/BackBtn';
import './style.scss';

const InnerHeading = ({
  decorLeft, decorRight, isInnerPage, parentPageTitle,
  title, icon, iconFirst, action, className, size, sorting,
}) => (
  <div className={`inner-heading top-section ${className || ''}`}>
    <ConditionalRenderer condition={decorLeft}>
      <If>
        <div className='inner-heading__decor decor-element'>
          <img width={550} height={520} src={decorLeft} alt='decor' />
        </div>
      </If>
    </ConditionalRenderer>
    <ConditionalRenderer condition={decorRight}>
      <If>
        <div className='inner-heading__decor decor-element'>
          <img width={550} height={520} src={decorRight} alt='decor' />
        </div>
      </If>
    </ConditionalRenderer>
    <div className='row align-center'>
      <div className={`column sm-12 ${size || ''}`}>
        <div className='inner-heading__wrap'>
          <div className='inner-heading__content'>
            <ConditionalRenderer condition={isInnerPage}>
              <If>
                <div className='inner-heading__back'>
                  <BackBtn />
                </div>
              </If>
            </ConditionalRenderer>
            <ConditionalRenderer condition={iconFirst && icon}>
              <If>
                <div className='inner-heading__icon'>
                  <img width={100} height={100} src={icon} alt='heading icon' />
                </div>
              </If>
            </ConditionalRenderer>
            <div className='inner-heading__title'>
              <ConditionalRenderer condition={parentPageTitle}>
                <If>
                  <div className='title-lg tablet-title-lg mobile-title-lg cursor' onClick={goBack}>{parentPageTitle}</div>
                </If>
              </ConditionalRenderer>
              <div className='title-lg tablet-title-lg mobile-title-lg'>{title}</div>
            </div>
            <ConditionalRenderer condition={!iconFirst && icon}>
              <If>
                <div className='inner-heading__icon'>
                  <img width={100} height={100} src={icon} alt='heading icon' />
                </div>
              </If>
            </ConditionalRenderer>
          </div>
          <ConditionalRenderer condition={action}>
            <If>
              <div className='inner-heading__action'>
                {action}
              </div>
            </If>
          </ConditionalRenderer>
          <ConditionalRenderer condition={sorting}>
            <If>
              <div className='inner-heading__sort'>
                {sorting}
              </div>
            </If>
          </ConditionalRenderer>
        </div>
      </div>
    </div>
  </div>
);

export default InnerHeading;
